import Service from '@ember/service';
import { service } from '@ember/service';
import Utils from '../utils/utils';

export default class HashService extends Service {
    @service tabService;
    @service('browser/window') window;

    originalHash = '';
    originalWindowHash = '';

    /**
     * Set original hash
     * Initialize tab service from hash
     */

    get locationHash() {
        return this.window.location.hash;
    }

    get parsedLocationHash() {
        return this.parseUrl(this.window.location.hash);
    }

    get loadedWithHash() {
        return this.window.location.hash !== '';
    }

    handleUrlParameters() {
        Object.keys(this.tabService.tabs.items).forEach((tabType) => {
            let tabList = this.tabService.tabs.items[tabType],
                selectedTab = tabList.find((tab) => tab.isSelected);

            if (selectedTab) this.setUrlParameter(selectedTab.type.urlKey, selectedTab.index);
        });
    }

    setUrlParameter(propertyName, value) {
        // TODO: Need to disable hash change here first, and move this into the hash-service. Look at firstlight for an example.
        if (!value && !(value === 0) && !(value === false)) {
            this.removeUrlParameter(propertyName, this.window.location.hash);
        } else {
            let map = this.parseUrl(this.window.location.hash);
            map[propertyName] = value;
            this.window.location.hash = Utils.stringify(map);
        }
    }

    removeUrlParameter(propertyName) {
        let map = this.parseUrl(this.window.location.hash);
        delete map[propertyName];
        this.window.location.hash = Utils.stringify(map);
    }

    parseUrl(str) {
        if (typeof str !== 'string') {
            return {};
        }

        str = str.trim().replace(/^(\?|#|&)/, '');

        if (!str) {
            return {};
        }

        return str.split('&').reduce((ret, param) => {
            var parts = param.replace(/\+/g, ' ').split('=');
            var key = parts[0];
            var val = parts[1];

            key = decodeURIComponent(key);

            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val === undefined ? null : decodeURIComponent(val);

            if (!(key in ret)) {
                ret[key] = val;
            } else if (Array.isArray(ret[key])) {
                ret[key].push(val);
            } else {
                ret[key] = [ret[key], val];
            }

            return ret;
        }, {});
    }
}
